import COLOR from '@fx-ui/color';

/**
 * 本文档颜色为研发、视觉共同确定的标准颜色变量表，不允许新增
 */
export const COLOR_VAR = {
    // 文本色
    text: COLOR.transparent2, // 主要文本, 场景：常用的文本颜色
    textSecondary: COLOR.transparent3, // 次要文本, 场景：一般用于和主要文本拉开层级，也是常用的icon颜色
    textTertiary: COLOR.transparent4, // 辅助文本, 场景：一些说明性/非重点的文本
    textQuaternary: COLOR.transparent5, // 禁用提示文本, 场景：禁用状态、提示类的文本
    textWhite: COLOR.white,

    // 边线
    border: COLOR.grey5, // 深色边线, 场景：控件描边
    borderSecondary: COLOR.grey4, // 中浅边线, 场景：表格边框线/部分组件的描边

    // 分割线,
    split: COLOR.grey4, // 场景：分割线颜色

    // 背景色
    bgContainer: COLOR.white, // 背景填充1, 场景：白色背景色
    background: COLOR.grey2, // 背景填充2, 场景：一般用于容器的背景色，也是常用的背景色
    bgDeep: COLOR.grey3, // 背景填充3, 场景：对于上层背景采用深色时（例如:grey11），采用该背景色

    // 错误状态
    error: COLOR.red6,
    errorBg: COLOR.red1,

    // 提醒状态
    warning: COLOR.yellow6,
    warningBg: COLOR.yellow1,

    // 成功状态(下个迭代修改为green)
    success: COLOR.green6,
    successBg: COLOR.green1,

    // 信息（提示）状态
    info: COLOR.blue6,
    infoBg: COLOR.blue1
};
